module.exports = (__webpack_require__(7))(51);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/platform-browser/esm5/platform-browser.js from dll-reference vendor
// module id = 57
// module chunks = 0